import { render, staticRenderFns } from "./fieldInfo.vue?vue&type=template&id=fa10a5c6&"
import script from "./fieldInfo.vue?vue&type=script&lang=js&"
export * from "./fieldInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports